import convert from 'color-convert';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import { GridActionButton } from '../../Asset/common';
import { useSelector } from 'react-redux';

//   const ExcelJS = require('exceljs');
//   const saveAs = require('file-saver'); //
// let Setting = useSelector(state => state.Setting.Setting);
async function generateExcel(columnConfig, data, filename, Setting, IsExcelSumary = false, CompCode) {

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Data');
    const filteredColumns = columnConfig?.filter(column => column.IsHide == false);
    // const filteredColumns = columnConfig;
    let ColumnHeader = []
    let ExcelFooterBackCol = Setting?.find(Setting => Setting.SKEY == 'ExcelFooterBackCol')?.SVALUE;
    let ExcelFooterForeCol = Setting?.find(Setting => Setting.SKEY == 'ExcelFooterForeCol')?.SVALUE;
    let ExcelHeaderBackCol = Setting?.find(Setting => Setting.SKEY == 'ExcelHeaderBackCol')?.SVALUE;
    let ExcelHeaderForeCol = Setting?.find(Setting => Setting.SKEY == 'ExcelHeaderForeCol')?.SVALUE;


    const getColorHex = (colorName) => {
        const rgbColor = convert.keyword.rgb(colorName);
        const hexColor = convert.rgb.hex(rgbColor);
        return `${hexColor}`;
    };

    filteredColumns.forEach(column => {
        ColumnHeader.push({
            header: column.ExcelHeader !== undefined && column.ExcelHeader !== null && column.ExcelHeader !== ''
                ? column.ExcelHeader
                : column.DispName,
            key: column.field,
            width: column.size / 7,
            fill: {
                type: 'pattern',
                pattern: 'solid',
            },
            numFmt: column.Format && (column.Format === '0' || column.Format === '0.00') ? column.Format : undefined
        });
    });


    worksheet.columns = ColumnHeader

    // === ADD GROUP HEADER ROW (using GroupKey) - Only when NOT in summary mode ===
    // === ADD GROUP HEADER ROW (using GroupKey) - Only when NOT in summary mode ===
    // === ADD GROUP HEADER ROW (using GroupKey) - Only when NOT in summary mode ===
    // === ADD GROUP HEADER ROW (using GroupKey) - Only when NOT in summary mode ===
    if (!IsExcelSumary) {

        // GroupKey na basis par CONSECUTIVE (adjacent) columns na segments banavo.
        // Same GroupKey vada columns j non-adjacent hoy to alag-alag segment banse,
        // jethi mergeCells nu range kadi biju group cover na kare (overlap error na ave).
        const segments = [];
        let current = null;

        filteredColumns.forEach((col, idx) => {
            const groupKey = col.GroupKey || col.group || ''; // blank = no group
            const colIndex = idx + 1; // ExcelJS 1-based indexing

            if (current && current.key === groupKey && groupKey !== '') {
                current.cols.push(colIndex);
            } else {
                current = { key: groupKey, cols: [colIndex] };
                segments.push(current);
            }
        });

        // Insert group header row at the beginning
        worksheet.spliceRows(1, 0, []);

        const groupRow = worksheet.getRow(1);

        // Pehla badhi columns par blank cell + border set karo
        filteredColumns.forEach((col, idx) => {
            const cell = groupRow.getCell(idx + 1);
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });

        // Have segments loop kari ne j GroupKey hoy tya merge + label karo
        segments.forEach(({ key, cols }) => {
            if (!key) return; // blank group -> cell blank j rehva do, kai na karo

            const startCol = cols[0];
            const endCol = cols[cols.length - 1];

            if (endCol > startCol) {
                worksheet.mergeCells(1, startCol, 1, endCol);
            }

            const cell = groupRow.getCell(startCol);
            cell.value = key;
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
            cell.font = { bold: true, size: 11 };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'D3D3D3' } // Light gray
            };
        });

        groupRow.height = 20;
    }
    // === HEADER ROW (Row 2 if group header added, Row 1 if summary mode) ===
    const headerRowNum = IsExcelSumary ? 1 : 2;
    const headerRow = worksheet.getRow(headerRowNum);
    headerRow.eachCell((cell) => {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: getColorHex(ExcelHeaderBackCol?.toLowerCase()) }
        };
        cell.font = {
            bold: true,
            color: { argb: getColorHex(ExcelHeaderForeCol?.toLowerCase()) }
        };
        cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        };
    });

    // Apply AutoFilter to all columns
    const headerRowForFilter = IsExcelSumary ? 7 : 2;
    worksheet.autoFilter = {
        from: { row: headerRowForFilter, column: 1 },
        to: { row: headerRowForFilter, column: filteredColumns.length },
    };

    ///////////////Shorting htu a bandh kryu as it is order joia chhe

    // data = data?.sort((a, b) => {

    //     const sA = (a.S_NAME ?? "")?.toString()?.toLowerCase();
    //     const sB = (b.S_NAME ?? "")?.toString()?.toLowerCase();

    //     if (sA < sB) return -1;
    //     if (sA > sB) return 1;

    //     return (parseFloat(a.I_CARAT ?? 0) - parseFloat(b.I_CARAT ?? 0));
    // });

    data?.forEach((row) => {

        const worksheetRow = worksheet.addRow(row);
        worksheetRow.eachCell({ includeEmpty: true }, cell => {
            const columnIndex = cell._column._number - 1; // Get column index
            const column = filteredColumns[columnIndex];


            if (
                cell.value &&
                typeof cell.value === "string" &&
                cell.value.includes("T") &&
                !isNaN(Date.parse(cell.value))
            ) {
                const [datePart] = cell.value.split("T"); // YYYY-MM-DD
                const [year, month, day] = datePart.split("-").map(Number);

                // Set time to 12:00 PM (timezone-safe for Excel)
                const dateObj = new Date(year, month - 1, day, 12, 0, 0);

                cell.value = dateObj;
                cell.numFmt = "dd-MM-yyyy";
            }


            // Apply cell background color
            if (column && column.ExcelBackCol && column.ExcelBackCol != '') {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    // fgColor: { argb: "B5C18E" }
                    fgColor: { argb: getColorHex(column.ExcelBackCol?.toLowerCase()) }
                };
            }

            // Apply cell foreground color
            if (column && column.ExcelForecol && column.ExcelForecol != '') {
                cell.font = {
                    // color: { argb: "f2632a" }
                    color: { argb: getColorHex(column.ExcelForecol?.toLowerCase()) }
                };
            }

            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };

            // ✅ GENERAL TYPE REMOVE KARINE "NUMBER" MA CONVERT KARVU
            if ((!cell.numFmt || cell.numFmt === 'General') && !isNaN(cell.value)) {
                if (column.DispFormate == '0.00') {
                    cell.value = Number(cell.value); // Convert to Number
                    cell.numFmt = '0.00'; // Default to 2 decimal places
                }
            }

            if (column && column.field?.toLowerCase() === 'certno' && row.REPORTLINK) {
                cell.value = {
                    text: row.CERTNO,
                    hyperlink: row.REPORTLINK,
                }
                cell.font = {
                    color: { argb: '0000FF' }
                }
            }

            if (column && column.field?.toLowerCase() === 'pdflink' && row.PDFLINK) {
                cell.value = {
                    text: row.PDFLINK,
                    hyperlink: row.PDFLINK,
                }
                cell.font = {
                    color: { argb: '0000FF' }
                }
            }

            if (column && column.field?.toLowerCase() === 'videolink1' && row.VIDEOLINK1) {
                cell.value = {
                    text: row.VIDEOLINK1,
                    hyperlink: row.VIDEOLINK1,
                }
                cell.font = {
                    color: { argb: '0000FF' }
                }
            }

            if (column && column.field?.toLowerCase() === 'videolink2' && row.VIDEOLINK2) {
                cell.value = {
                    text: row.VIDEOLINK2,
                    hyperlink: row.VIDEOLINK2,
                }
                cell.font = {
                    color: { argb: '0000FF' }
                }
            }

            if (column && column.field?.toLowerCase() === 'photolink' && row.PHOTOLINK) {
                cell.value = {
                    text: row.PHOTOLINK,
                    hyperlink: row.PHOTOLINK,
                }
                cell.font = {
                    color: { argb: '0000FF' }
                }
            }

            if (column && column.field?.toLowerCase() === 'reportlink' && row.REPORTLINK) {
                cell.value = {
                    text: row.REPORTLINK,
                    hyperlink: row.REPORTLINK,
                }
                cell.font = {
                    color: { argb: '0000FF' }
                }
            }

            let dataRowOffset;
            if (CompCode == 'Vanora') {
                dataRowOffset = IsExcelSumary ? 6 : 0; // +1 for group header when no summary, +6 for summary
            }
            else{
                dataRowOffset = IsExcelSumary ? 8 : 0; // +1 for group header when no summary, +6 for summary
            }
            
            const excelRow = worksheetRow.number + dataRowOffset; // Offset for formula references

            const getLetter = (field) => {
                const idx = filteredColumns.findIndex(
                    (c) => c.field?.toUpperCase() === field.toUpperCase()
                );
                return idx >= 0 ? getExcelColumnLetter(idx) : null;
            };

            // --- RATE formula = ORATE - (ORATE * DISC / 100)
            // if (column.field?.toUpperCase() === 'RATE') {
            //     const orateLetter = getLetter('ORATE');
            //     const discLetter = getLetter('DISC');
            //     if (orateLetter && discLetter) {
            //         cell.value = {
            //             formula: `=${orateLetter}${excelRow} - (${orateLetter}${excelRow} * ${discLetter}${excelRow} / 100)`
            //         };
            //         cell.numFmt = '####0.00';
            //     }
            // }


            // --- DISC formula = (100-((RATE/O_RATE)*100))
            if (column.field?.toUpperCase() === 'DISC') {
                const rateLetter = getLetter('RATE');
                const orateLetter = getLetter('ORATE');
                if (rateLetter && orateLetter) {
                    cell.value = {
                        formula: `=100-((${rateLetter}${excelRow}/${orateLetter}${excelRow})*100)`
                    };
                    cell.numFmt = '####0.00';
                }
            }

            // --- AMT formula = RATE * I_CARAT
            if (column.field?.toUpperCase() === 'AMT') {
                const rateLetter = getLetter('RATE');
                const caratLetter = getLetter('I_CARAT');
                if (rateLetter && caratLetter) {
                    cell.value = {
                        formula: `=${rateLetter}${excelRow} * ${caratLetter}${excelRow}`
                    };
                    cell.numFmt = '####0.00';
                }
            }

        });
    });


    function getExcelColumnLetter(index) {
        let letter = '';
        while (index >= 0) {
            letter = String.fromCharCode((index % 26) + 65) + letter;
            index = Math.floor(index / 26) - 1;
        }
        return letter;
    }


    // worksheet.addRow([]);
    // Add Total Row 
    const totalRow = {};

    const dataStartRow = IsExcelSumary == true ? 8 : 3; // Data starts at row 3 (no summary) or row 8 (with summary)

    debugger
    filteredColumns.forEach((column, index) => {
        const colLetter = String.fromCharCode(65 + index); // Convert index to Excel column letter (A, B, C...)

        debugger
        if (column.ExcelFormula) {

            if (column.ExcelFormula.toUpperCase() === "COUNT") {
                totalRow[column.field] = {
                    formula: `COUNT(${colLetter}${dataStartRow}:${colLetter}${dataStartRow + data.length - 1})`
                };

            }
            else if (column.ExcelFormula.toUpperCase() === "SUM") {
                totalRow[column.field] = {
                    formula: `SUM(${colLetter}${dataStartRow}:${colLetter}${dataStartRow + data.length - 1})`
                };
            }
            else {

                const [primaryColumn, dependentCols] = column.ExcelFormula.split('=');
                const dependentColumns = dependentCols.split(',').map(col => col.trim());

                const columnIndices = dependentColumns.map(field =>
                    filteredColumns.findIndex(col => col.field.toUpperCase() === field)
                );

                if (columnIndices.includes(-1)) return; // Skip if column not found

                const colLetters = columnIndices.map(idx => getExcelColumnLetter(idx));
                if (primaryColumn.toUpperCase() === "ROWNO") {
                    totalRow[primaryColumn] = {
                        formula: `COUNT(${colLetters[0]}${dataStartRow}:${colLetters[0]}${dataStartRow + data.length})`
                    };
                }
                else if (primaryColumn.toUpperCase() === "I_CARAT") {

                    debugger
                    totalRow[primaryColumn] = {
                        formula: `SUM(${colLetters[0]}${dataStartRow}:${colLetters[0]}${dataStartRow + data.length})`
                    };
                }
                else if (primaryColumn.toUpperCase() === "AMT") {
                    totalRow[primaryColumn] = {
                        formula: `SUM(${colLetters[0]}${dataStartRow}:${colLetters[0]}${dataStartRow + data.length})`
                    };
                }
                else if (primaryColumn.toUpperCase() === "RATE") {
                    totalRow[primaryColumn] = {
                        formula: `SUM(${colLetters[0]}${dataStartRow}:${colLetters[0]}${dataStartRow + data.length}) / SUM(${colLetters[1]}${dataStartRow}:${colLetters[1]}${dataStartRow + data.length})`
                    };
                }
                else if (primaryColumn.toUpperCase() === "DISC") {

                    const RAmtindex = filteredColumns.findIndex(c => c.field.toUpperCase() === "OAMT");
                    const RamtLeter = getExcelColumnLetter(RAmtindex);
                    const lastRow = dataStartRow + data.length - 2;
                    const RAmtSum = `SUM(${RamtLeter}${dataStartRow}:${RamtLeter}${lastRow})`;


                    const Amtindex = filteredColumns.findIndex(c => c.field.toUpperCase() === "AMT");
                    const amtLeter = getExcelColumnLetter(Amtindex);
                    const AmtSum = `SUM(${amtLeter}${dataStartRow}:${amtLeter}${lastRow})`;


                    totalRow[primaryColumn] = {
                        formula: `=100 - ((${AmtSum}/${RAmtSum})*100)`
                    };

                }
                else if (primaryColumn.toUpperCase() === "ORATE") {

                    const columnIndices = dependentColumns.map(field =>
                        filteredColumns.findIndex(col => col.field.toUpperCase() === field)
                    );

                    if (columnIndices.length >= 2) {
                        const colLetters = columnIndices.map(idx => getExcelColumnLetter(idx));

                        const caratIndex = columnIndices.find(idx => filteredColumns[idx].field.toUpperCase().includes("CARAT"));
                        if (caratIndex !== undefined) {
                            const caratColumnLetter = getExcelColumnLetter(caratIndex);

                            totalRow[primaryColumn] = {
                                formula: `SUMPRODUCT(${colLetters[0]}${dataStartRow}:${colLetters[0]}${dataStartRow + data.length}, ${colLetters[1]}${dataStartRow}:${colLetters[1]}${dataStartRow + data.length}) / SUM(${caratColumnLetter}${dataStartRow}:${caratColumnLetter}${dataStartRow + data.length})`
                            };
                        }
                    }
                }
            }
        }
    });

    if (!IsExcelSumary) {
        const totalRowRef = worksheet.addRow(totalRow);
        totalRowRef.eachCell({ includeEmpty: true }, cell => {
            cell.font = {
                bold: true,
                size: 12,
                color: { argb: getColorHex(ExcelFooterForeCol?.toLowerCase()) }
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: getColorHex(ExcelFooterBackCol?.toLowerCase()) }
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });
    }


    // --- ADD SUMMARY BOX IF DATA EXISTS ---
    if (IsExcelSumary && data && data.length > 0) {

        // --- Column mapping ---
        const colMap = {
            PCS: filteredColumns.findIndex(c => c.field.toUpperCase() === "ROWNO"),
            I_CARAT: filteredColumns.findIndex(c => c.field.toUpperCase() === "I_CARAT"),
            ORATE: filteredColumns.findIndex(c => c.field.toUpperCase() === "ORATE"),
            OAMT: filteredColumns.findIndex(c => c.field.toUpperCase() === "OAMT"),
            DISC: filteredColumns.findIndex(c => c.field.toUpperCase() === "DISC"),
            RATE: filteredColumns.findIndex(c => c.field.toUpperCase() === "RATE"),
            AMT: filteredColumns.findIndex(c => c.field.toUpperCase() === "AMT")
        };

        const startCol = 8; // Starting column (H)
        const totalCols = 7; // Total 7 subcolumns
        const endCol = startCol + totalCols - 1;

        // --- Insert space for summary section ---
        worksheet.spliceRows(1, 0, [], [], [], [], [], []);
        const titleRow = worksheet.getRow(1);
        const groupHeaderRow = worksheet.getRow(2);
        const subHeaderRow = worksheet.getRow(3);
        const totalRow = worksheet.getRow(4);
        const filteredRow = worksheet.getRow(5);

        // --- Summary Title ---
        const today = new Date();
        const formattedDate = today.toLocaleDateString("en-GB");
        titleRow.getCell(startCol).value = `SUMMARY (${formattedDate})`;
        worksheet.mergeCells(1, startCol, 1, endCol);
        titleRow.height = 22;
        titleRow.getCell(startCol).alignment = { horizontal: 'center', vertical: 'middle' };
        titleRow.getCell(startCol).font = { bold: true, size: 13, color: { argb: 'FFFFFF' } };
        titleRow.getCell(startCol).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: getColorHex(ExcelFooterBackCol?.toLowerCase()) }
        };
        // --- Group Headers ---
        const groups = [
            { name: "Total", from: startCol, to: startCol + 1, color: "F4B084" },
            { name: "Rap", from: startCol + 2, to: startCol + 3, color: "92D050" },
            { name: "Value", from: startCol + 4, to: startCol + 6, color: "BDD7EE" }
        ];

        groups.forEach(g => {
            worksheet.mergeCells(2, g.from, 2, g.to);
            const cell = groupHeaderRow.getCell(g.from);
            cell.value = g.name;
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
            cell.font = { bold: true };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: g.color } };
            for (let i = g.from; i <= g.to; i++) {
                const c = groupHeaderRow.getCell(i);
                c.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            }
        });

        // --- Subheaders ---
        const headers = ["Pcs", "Crt", "Price", "OAmt", "Disc %", "Price", "Amt"];
        headers.forEach((h, i) => {
            const col = startCol + i;
            const cell = subHeaderRow.getCell(col);
            cell.value = h;
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D9E1F2' } };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });

        const firstRow = 8;
        const lastRow = data.length + 7;

        /////LensiSukhadiya
        // --- Pcs (Count)
        const totalPcs = data.length;
        const PcsLetter = getExcelColumnLetter(colMap.PCS);
        totalRow.getCell(startCol).value = totalPcs;
        filteredRow.getCell(startCol).value = { formula: `SUBTOTAL(3,${PcsLetter}${firstRow}:${PcsLetter}${lastRow})` };

        // --- Carat Total ---
        const caratLetter = getExcelColumnLetter(colMap.I_CARAT);
        const totalCarat = data.reduce((sum, r) => sum + (r.I_CARAT || 0), 0);
        totalRow.getCell(startCol + 1).value = totalCarat;
        filteredRow.getCell(startCol + 1).value = { formula: `SUBTOTAL(9, ${caratLetter}${firstRow}:${caratLetter}${lastRow})` };

        // --- Rap Price (ORATE Weighted Avg) ---
        const orateLetter = getExcelColumnLetter(colMap.ORATE);
        const sumProduct = data.reduce((sum, r) => sum + ((r.I_CARAT || 0) * (r.ORATE || 0)), 0);
        const avgORate = totalCarat > 0 ? sumProduct / totalCarat : 0;
        totalRow.getCell(startCol + 2).value = avgORate;
        filteredRow.getCell(startCol + 2).value = {
            formula: `=IFERROR(SUMPRODUCT(${caratLetter}${firstRow}:${caratLetter}${lastRow}, ${orateLetter}${firstRow}:${orateLetter}${lastRow}) / SUM(${caratLetter}${firstRow}:${caratLetter}${lastRow}), 0)`
        };

        // --- OAmt (Sum) ---
        const oamtLetter = getExcelColumnLetter(colMap.OAMT);
        const totalOAmt = data.reduce((sum, r) => sum + (r.OAMT || 0), 0);
        totalRow.getCell(startCol + 3).value = totalOAmt;
        filteredRow.getCell(startCol + 3).value = { formula: `SUBTOTAL(9, ${oamtLetter}${firstRow}:${oamtLetter}${lastRow})` };

        // --- Disc % ---
        const amtLetter = getExcelColumnLetter(colMap.AMT);
        const totalAmt = data.reduce((sum, r) => sum + (r.AMT || 0), 0);
        const discVal = totalOAmt > 0 ? 100 - ((totalAmt / totalOAmt) * 100) : 0;
        totalRow.getCell(startCol + 4).value = discVal;
        filteredRow.getCell(startCol + 4).value = {
            formula: `=IFERROR(100 - ((SUBTOTAL(9,${amtLetter}${firstRow}:${amtLetter}${lastRow}) / SUBTOTAL(9,${oamtLetter}${firstRow}:${oamtLetter}${lastRow})) * 100), 0)`
        };

        // --- Rate (Price) = SUM(AMT) / SUM(CARAT)
        const avgRate = totalCarat > 0 ? totalAmt / totalCarat : 0;
        totalRow.getCell(startCol + 5).value = avgRate;
        // filteredRow.getCell(startCol + 5).value = {
        //     formula: `=IFERROR(SUM(${amtLetter}${firstRow}:${amtLetter}${lastRow}) / SUM(${caratLetter}${firstRow}:${caratLetter}${lastRow}), 0)`
        // };

        filteredRow.getCell(startCol + 5).value = {
            formula: `=IFERROR(SUBTOTAL(109,${amtLetter}${firstRow}:${amtLetter}${lastRow})/SUBTOTAL(109,${caratLetter}${firstRow}:${caratLetter}${lastRow}),0)`
        };

        // --- Amt (Sum) ---
        totalRow.getCell(startCol + 6).value = totalAmt;
        filteredRow.getCell(startCol + 6).value = { formula: `SUBTOTAL(9, ${amtLetter}${firstRow}:${amtLetter}${lastRow})` };

        // --- Common formatting for total + filtered rows ---
        [totalRow, filteredRow].forEach(row => {
            for (let i = startCol; i <= endCol; i++) {
                const cell = row.getCell(i);
                cell.numFmt = '#,##0.00';
                cell.alignment = { horizontal: 'center' };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            }
        });

        // --- Row labels ---
        const totalLabel = worksheet.getCell(4, startCol - 1);
        totalLabel.value = "Total";
        totalLabel.font = { bold: true };
        totalLabel.alignment = { horizontal: "center", vertical: "middle" };
        totalLabel.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "F4B084" } };

        const filteredLabel = worksheet.getCell(5, startCol - 1);
        filteredLabel.value = "Filtered Total";
        filteredLabel.font = { bold: true };
        filteredLabel.alignment = { horizontal: "center", vertical: "middle" };
        filteredLabel.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "92D050" } };

        // Formate mate
        [totalRow, filteredRow].forEach(row => {
            for (let i = startCol; i <= endCol; i++) {
                const cell = row.getCell(i);

                const header = ["PCS", "I_CARAT", "ORATE", "OAMT", "DISC", "RATE", "AMT"][i - startCol];

                if (["PCS", "OAMT", "ORATE"].includes(header)) {
                    cell.numFmt = '#,##0';  // Whole number, no decimals
                } else {
                    cell.numFmt = '#,##0.00';
                }

                cell.alignment = { horizontal: 'center' };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            }
        });
    }


    // // Append total row and make it bold
    // const totalRowRef = worksheet.addRow(totalRow);
    // totalRowRef.fill = {
    //     type: 'pattern',
    //     pattern: 'solid',
    //     fgColor: { argb: getColorHex(ExcelFooterBackCol?.toLowerCase()) }
    // }
    // totalRowRef.eachCell(cell => {
    //     cell.font = {
    //         bold: true, size: 14,
    //         color: { argb: getColorHex(ExcelFooterForeCol?.toLowerCase()) }
    //     };
    //     // cell.fill = {
    //     //     type: 'pattern',
    //     //     pattern: 'solid',
    //     //     fgColor: { argb: getColorHex(ExcelFooterBackCol.toLowerCase()) }
    //     // };
    // });


    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, filename);
}

// module.exports = generateExcel;
export default generateExcel;
